import './OrderWhatsNext.scss';

import { useEffect } from 'react';
import { Container } from 'react-bootstrap';
import { Link, useLocation } from 'react-router';
import { faEnvelope, faUserCheck } from '@fortawesome/pro-regular-svg-icons';
import { faLaptopMedical } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from '@myome/ui';

import { FormPanel } from '@components/FormPanel/FormPanel';
import { ROUTES } from '@constants/routes';
import { useKeycloak } from '@hooks/useKeycloak';
import { recordGoogleAnalyticsEvent, recordGoogleAnalyticsSend } from '@utils/helpers';

import { useOrderContext } from './hooks/useOrderContext';
import { OrderActions } from './types/Order.actions';

export const OrderWhatsNext = () => {
  const { keycloak } = useKeycloak();
  const { pathname, search, state: locationState } = useLocation();
  const { dispatch } = useOrderContext();
  const isRerequisition = locationState?.isRerequisition === true;

  useEffect(() => {
    dispatch({ type: OrderActions.RESET });
  }, [dispatch]);

  useEffect(() => {
    const path = `${pathname}${search}`;
    recordGoogleAnalyticsSend('pageview', path, "Partner order: What's next");
  }, [pathname, search]);

  const onAccountSetUp = () => {
    recordGoogleAnalyticsEvent('User Interaction', 'Button Click', 'Set up your account: Whats Next');
    const registrationUrl = keycloak?.createRegisterUrl();
    if (registrationUrl) {
      window.location.href = registrationUrl;
    }
  };

  if (isRerequisition) {
    return (
      <main className='rerequisition-confirmation'>
        <FormPanel maxWidth='sm' layout='sectioned'>
          <FormPanel.Header title='Your order has been submitted' />
          <FormPanel.Body>
            <p className='mb-0'>We&apos;ll review your order and email you when its status changes.</p>
          </FormPanel.Body>
          <FormPanel.Footer variant='actions'>
            <Link to={ROUTES.MY_ORDERS} className='btn btn-primary'>
              View my orders
            </Link>
          </FormPanel.Footer>
        </FormPanel>
      </main>
    );
  }

  return (
    <Container className='partner-order-whats-next py-4'>
      <h1 className='partner-order-whats-next__title text-center mb-4'>Your order has been submitted for review!</h1>
      <div className='partner-order-whats-next__panel border rounded p-4 text-center'>
        <h2 className='text-accent-aqua-1 fs-4 fw-semibold border-bottom pb-3 mb-4'>What Happens Next?</h2>
        <div className='text-start'>
          <div className='d-flex gap-3 mb-4'>
            <FontAwesomeIcon icon={faUserCheck} className=' mt-1 text-accent-aqua-1 flex-shrink-0 fs-4' />
            <p className='mb-0'>Finish setting up your account by clicking on the button below</p>
          </div>
          <div className='d-flex gap-3 mb-4'>
            <FontAwesomeIcon icon={faLaptopMedical} className=' text-accent-aqua-1 flex-shrink-0 fs-4 mt-1' />
            <p className='mb-0'>Login to our patient&apos;s portal to keep track of your request</p>
          </div>
          <div className='d-flex gap-3'>
            <FontAwesomeIcon icon={faEnvelope} className=' text-accent-aqua-1 flex-shrink-0 fs-4 mt-1' />
            <p className='mb-0'>We will be sending you updates about your request via email</p>
          </div>
        </div>
      </div>
      <div className='mt-4 d-flex justify-content-center'>
        <Button variant='secondary' onClick={onAccountSetUp}>
          Finish setting up your account
        </Button>
      </div>
    </Container>
  );
};
